'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _redux = require('redux');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _HomePage = require('../../components/HomePage/HomePage');var _HomePage2 = _interopRequireDefault(_HomePage);
var _mobilesFilters = require('../../redux/modules/mobilesFilters');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _checkUserAgent = require('../../utils/checkUserAgent');var _checkUserAgent2 = _interopRequireDefault(_checkUserAgent);
var _routerAdapter = require('../../helpers/routerAdapter');
var _propertySearch = require('../../redux/modules/propertySearch');
var _homePageProperties = require('../../redux/modules/homePageProperties');
var _citiesTranslations = require('../../translations/cities/citiesTranslations');var _citiesTranslations2 = _interopRequireDefault(_citiesTranslations);
var _recentSearches = require('../../redux/modules/recentSearches');
var _propertyDetails = require('../../redux/modules/propertyDetails');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
var HomePageWrapper = function (_Component) {_inherits(HomePageWrapper, _Component);
  function HomePageWrapper(props) {_classCallCheck(this, HomePageWrapper);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));
    _this.state = {
      isMobileOrTablet: _checkUserAgent2.default.isMobileOrTablet(navigator.userAgent) };return _this;

  }HomePageWrapper.prototype.

  componentDidMount = function componentDidMount() {
    if (this.props.isMobile) {
      this.props.suppressLoading(false);
    } else {
      var id = (0, _get2.default)(this.props, 'location.query.id');

      if (id) {
        var firstUnderscoreIndex = id.indexOf('_');
        var entityType = id.substring(0, firstUnderscoreIndex);
        var propertyId = id.substring(firstUnderscoreIndex + 1);

        this.props.openDetailsPopup({ entityType: entityType, propertyId: propertyId });
      }
    }

    this.props.parseSavedRecentSearches();
  };HomePageWrapper.prototype.

  shouldComponentUpdate = function shouldComponentUpdate(_ref) {var route = _ref.route,locale = _ref.locale,location = _ref.location;
    // TODO: Continue rendering optimisation + props separation
    var localeIsChanged = route === (0, _appendLocale2.default)(locale, '/') || route === '/he/';
    var locationIsChanged = location.query !== this.props.location.query;
    return localeIsChanged || locationIsChanged;
  };HomePageWrapper.prototype.

  render = function render() {
    var props = Object.assign({},
    this.props, {
      isMobileOrTablet: this.state.isMobileOrTablet });


    return (
      _react2.default.createElement(_HomePage2.default, _extends({}, props, { citiesLinksData: _citiesTranslations2.default })));

  };return HomePageWrapper;}(_react.Component);


HomePageWrapper.displayName = 'HomePageWrapper';
HomePageWrapper.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool.isRequired,
  route: _propTypes2.default.string.isRequired,
  suppressLoading: _propTypes2.default.func,
  loadProperties: _propTypes2.default.func,
  parseSavedRecentSearches: _propTypes2.default.func,
  resentSearches: _propTypes2.default.array,
  favoriteIDs: _propTypes2.default.array,
  location: _propTypes2.default.object,
  userData: _propTypes2.default.object,
  openDetailsPopup: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(state) {
  var routeData = (0, _routerAdapter.extractRouteData)(state.routing, state.lang.locale);

  return {
    userData: state.userAuthentication.data,
    locale: routeData.locale,
    route: routeData.route,
    isMobile: state.windowDimentions.isMobile,
    langStatic: (0, _reduxPagan.getLang)(state.lang, 'static'),
    majorCitiesData: state.cities.data,
    propertyTypes: state.propertyTypes.sorted || {},
    resentSearches: state.recentSearches.data,
    favoriteIDs: state.favoriteProperties.favoriteIDs || [] };

};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {return (0, _redux.bindActionCreators)({
    openMobileFilters: _mobilesFilters.openMobileFilters,
    suppressLoading: _propertySearch.suppressLoading,
    loadProperties: _homePageProperties.loadProperties,
    openDetailsPopup: _propertyDetails.openDetailsPopup,
    parseSavedRecentSearches: _recentSearches.parseSavedRecentSearches },

  dispatch);};exports.default =

(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HomePageWrapper);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomePage/HomePage.js
// module id = 3050
// module chunks = 0